module.exports = __webpack_public_path__ + "img/default.24c78dee.png";